import React from "react";

import { Context } from "../backend/context";
import { Redirect } from "react-router";

export default function Maintenance() {
  const { maintenance } = React.useContext(Context);

  return (
    <div className="container-fluid pt-5 badge-dark">
      {!maintenance && <Redirect to="/" />}
      <div className="container-fluid h-50 text-center">
        <div className="row">
          <div
            className="col-12 text-center h2 pb-3"
            style={{ color: "white" }}
          >
            Temporarily Down For Maintenance
          </div>
        </div>
      </div>
    </div>
  );
}
